import * as $ from 'jquery';
import { IDialog, IDialogOptions } from 'runtime/dialogs/dialog';
import { IResourceProvider } from 'common/resourceprovider';
import { ClaimFailureReason } from 'runtime/messages/workitemnotavailableforclaim';
import { UserInfo } from 'runtime/data/userinfo';
import { format } from 'common/functions/string';

export class WorkItemNotAvailableForClaimDialog implements IDialog {
    private dialogContent: JQuery;
    options: IDialogOptions;

    constructor(claimFailureReason: string, claimUserInfo: UserInfo, resources: IResourceProvider) {
        var message: string;
        switch (claimFailureReason) {
            case ClaimFailureReason.claimedByCurrentUser:
                message = resources.getCoreString('MsgClaimFailureReasonClaimedByCurrentUser');
                break;
            case ClaimFailureReason.claimedByAnotherUser:
                message = format(resources.getCoreString('MsgClaimFailureReasonClaimedByAnotherUserWinafc'), claimUserInfo.displayName);
                break;
            case ClaimFailureReason.stepCompleted:
                message = resources.getCoreString('MsgClaimFailureReasonStepCompletedWinafc');
                break;
            case ClaimFailureReason.unknown:
            default:
                message = resources.getCoreString('MsgClaimFailureReasonUnknown');
                break;
        }

        this.dialogContent = $('<div />').css('margin', '10px').text(message);

        this.options = {
            title: resources.getCoreString('WorkItemNotAvailableForClaimDialogTitle'),
            width: 525,
            height: 275,
            dialogClass: 'wf-dialog',
            buttons: [
                { text: resources.getCoreString('XamlClose'), click: () => this.dialogContent.dialog('close') }
            ]
        };
    }

    content(): JQuery {
        return this.dialogContent;
    }
}